/* eslint-disable import/prefer-default-export,react/jsx-props-no-spreading,import/no-unresolved */
import React from 'react';
import LedgerLogo from 'assets/images/ledger-logo.svg';
import ClLogo from 'assets/images/cl-logo.svg';

export const PromoLogo = () => (
  <>
    {/* mobile */}
    <div
      className="d-flex d-md-none align-items-center justify-content-between"
      style={{ gap: '8px' }}>
      <img width={60} src={ClLogo} alt="Logo" />
      <i
        className="close-btn cursor-pointer icon icon-close-other text-shadow"
        aria-label="Close"
      />
      <img height={22} src={LedgerLogo} alt="Logo" />
    </div>
    {/* browser */}
    <div
      className="d-none d-md-flex align-items-center justify-content-between"
      style={{ gap: '24px' }}>
      <img width={112} src={ClLogo} alt="Logo" />
      <i
        className="close-btn cursor-pointer icon icon-close-other text-shadow"
        aria-label="Close"
      />
      <img height={31} className="d-none d-md-block" src={LedgerLogo} alt="Logo" />
    </div>
  </>
);
